import { render, staticRenderFns } from "./movableBulletBox.vue?vue&type=template&id=668d9451&scoped=true&"
import script from "./movableBulletBox.vue?vue&type=script&lang=js&"
export * from "./movableBulletBox.vue?vue&type=script&lang=js&"
import style0 from "./movableBulletBox.vue?vue&type=style&index=0&id=668d9451&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d9451",
  null
  
)

export default component.exports